import {
  SEARCH_INPUT_CHANGE,
  SEARCH_AUTOSUGGEST_SUCCESS,
  SEARCH_INPUT_BLUR,
  SEARCH_INPUT_FOCUS,
} from './types';

const initialState = {
  query: '',
  focus: false,
  suggestions: [],
  loading: false,
};

function reducer(state = initialState, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case SEARCH_INPUT_CHANGE:
      return { ...state, query: action.query, loading: true };
    case SEARCH_AUTOSUGGEST_SUCCESS:
      return { ...state, suggestions: action.suggestions, loading: false };
    case SEARCH_INPUT_FOCUS:
      return { ...state, focus: true };
    case SEARCH_INPUT_BLUR:
      return {
        ...state,
        focus: false,
        query: '',
        suggestions: [],
        loading: false,
      };
    default:
      return state;
  }
}

export { reducer as default };



// WEBPACK FOOTER //
// ./src/search/reducer.js